import { CnInputTextArea as CnInputTextAreaView } from './cn-input-textarea';
import { withI18n } from 'panda-i18n';
import locale from '@/locale';
const CnInputTextArea = withI18n(CnInputTextAreaView, {
    locale,
    componentName: 'CnInputTextarea',
    _noHoc: true,
});
export { CnInputTextArea };
